import actionCreatorFactory from 'typescript-fsa';

import reduxConfig from '../../config';

const actionCreator = actionCreatorFactory(reduxConfig.appName + '/pdf');

export const previewLoadReport = actionCreator.async<{ entity: string }, any>('PREVIEW_DOWNLOAD_LIST');
export const resetPDFURL = actionCreator('SET_PDF_URL');
